import { callApiToServer } from "../callApi";

export async function addCharity(authtoken, charityObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      corppass_id: charityObject.corppass_id,
      categories: charityObject.categories,
      entity_name: charityObject.entity_name,
      primary_activity: charityObject.primary_activity,
      secondary_activity: charityObject.secondary_activity,
    });

    let endUrl = "v1/auth/charity";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
